import { useTypedSelector } from 'state';

export function useInitConfig() {
  return useTypedSelector(state => state.initConfig);
}
